/* eslint-disable */
export default {
  copy: '복사',
} as const;

// @key: @#@"copy"@#@ @source: @#@"Copy"@#@
